import { render, staticRenderFns } from "./NotificationIcon.vue?vue&type=template&id=59da2cfa&scoped=true&"
import script from "./NotificationIcon.vue?vue&type=script&lang=js&"
export * from "./NotificationIcon.vue?vue&type=script&lang=js&"
import style0 from "./NotificationIcon.vue?vue&type=style&index=0&id=59da2cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da2cfa",
  null
  
)

export default component.exports